import React from 'react';

import { Navigate, Outlet, useNavigation } from 'react-router-dom';

import { useAppSelector } from '@pkg/hooks';

import { NavigationState } from '@app/routes/types';
import { useAuthTokens } from '@app/store/zustand/auth/useAuthTokens';

export const PublicRoute = () => {
    const navigation = useNavigation();
    const { isAuthenticated } = useAuthTokens();

    const isRegisteredUser = useAppSelector((state) => state.user.isRegisteredUser);

    const shouldRedirect = isAuthenticated && isRegisteredUser && navigation.state === NavigationState.Idle;

    return !shouldRedirect ? <Outlet /> : <Navigate replace to="/" />;
};
